import React from 'react'
import update from 'immutability-helper';
import { browserHistory } from 'react-router'

import { group } from '../../core/controllers/Group';
import { modal } from '../../core/utilities/modal'

export default class GlobalUtilities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            disposalAmount: this.formatAmount(props.disposalAmount),
            waterAmount: this.formatAmount(props.waterAmount),
            sewageAmount: this.formatAmount(props.sewageAmount)
        }
    }

    componentDidMount() {}

    formatAmount(value) {
       var money = parseInt(value);
       money = Number(money.toFixed(2)).toLocaleString();
       if(money == 'NaN') { money = 0; }

       return money;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    handleDisposalAmountChange(e) {
        var money = this.formatAmount(e.target.value);

        this.setState({
            disposalAmount: money
        });
    }

    handleWaterAmountChange(e) {
        var money = this.formatAmount(e.target.value);

        this.setState({
            waterAmount: money
        });
    }

    handleSewageAmountChange(e) {
        var money = this.formatAmount(e.target.value);


        this.setState({
            sewageAmount: money
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    handleSaveGlobalUtilities() {
        const disposalAmount = this.state.disposalAmount;
        const waterAmount = this.state.waterAmount;
        const sewageAmount = this.state.sewageAmount;

        var monthlyUtilities = {
            disposalAmount: disposalAmount,
            waterAmount: waterAmount,
            sewageAmount: sewageAmount
        }

        group.saveGroupUtility(this.props.groupId, monthlyUtilities, function(response) {
            modal.showInfo("Your tenants associated with this group will now get the utility bills split between them.", "success", "top", "center");
        });
    }

    render(){
        const disposalAmount = this.state.disposalAmount;
        const waterAmount = this.state.waterAmount;
        const sewageAmount = this.state.sewageAmount;
        return (
            <div class="content">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="email">Monthly Disposal</label>
                            <div class="form-group has-feedback">
                                <input type="text" value={disposalAmount} onChange={this.handleDisposalAmountChange.bind(this)} class="form-control tenant-info input-group-dollar-addon" name="amount" placeholder="Amount" id="amount"/>
                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="email">Monthly Water</label>
                            <div class="form-group has-feedback">
                                <input type="text" value={waterAmount} onChange={this.handleWaterAmountChange.bind(this)} class="form-control tenant-info input-group-dollar-addon" name="amount" placeholder="Amount" id="amount"/>
                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="email">Monthly Sewage</label>
                            <div class="form-group has-feedback">
                                <input type="text" value={sewageAmount} onChange={this.handleSewageAmountChange.bind(this)} class="form-control tenant-info input-group-dollar-addon" name="amount" placeholder="Amount" id="amount"/>
                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button type="button" id="save-message" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveGlobalUtilities.bind(this)}>
                        Save Monthly Utilities
                        </button>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Group/GlobalUtilities.jsx